import { render, staticRenderFns } from "./TeachingAndResearchDetail.vue?vue&type=template&id=3a145b77&scoped=true&"
import script from "./TeachingAndResearchDetail.vue?vue&type=script&lang=js&"
export * from "./TeachingAndResearchDetail.vue?vue&type=script&lang=js&"
import style0 from "./TeachingAndResearchDetail.vue?vue&type=style&index=0&id=3a145b77&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a145b77",
  null
  
)

export default component.exports